import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

interface DemoModeCtx {
  demoMode: boolean;
  setDemoMode: (v: boolean) => void;
}

const Ctx = createContext<DemoModeCtx>({ demoMode: false, setDemoMode: () => {} });

export function DemoModeProvider({ children }: { children: ReactNode }) {
  const [demoMode, setDemoModeState] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const stored = localStorage.getItem("rt:demo");
    if (stored === "1") setDemoModeState(true);
  }, []);

  const setDemoMode = (v: boolean) => {
    setDemoModeState(v);
    if (typeof window !== "undefined") {
      localStorage.setItem("rt:demo", v ? "1" : "0");
    }
  };

  return <Ctx.Provider value={{ demoMode, setDemoMode }}>{children}</Ctx.Provider>;
}

export const useDemoMode = () => useContext(Ctx);
